var React = require('react');

function TiktokIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48,0C21.5,0,0,21.5,0,48c0,26.5,21.5,48,48,48c26.5,0,48-21.5,48-48C96,21.5,74.5,0,48,0z M74.8,41.4\n\tc-5,0.5-9.4-1.1-14.5-4.2v18.7c0,23.7-25.9,31.2-36.3,14.1c-6.7-11-2.6-30.2,18.9-30.9v10.5c-1.6,0.3-3.4,0.7-5,1.2\n\tc-4.8,1.6-7.5,4.6-6.7,10c1.4,10.2,20.2,13.2,18.6-6.7V16.7h10.4v0c1,8.9,6,14.2,14.6,14.7V41.4z"}));
}

TiktokIcon.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 96 96","fill":"currentColor","xmlSpace":"preserve"};

module.exports = TiktokIcon;

TiktokIcon.default = TiktokIcon;
